import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class EnterToSendPlugin extends Plugin {
	static get pluginName() {
		return 'EnterToSendPlugin';
	}

	init() {
		const editor = this.editor;

		const cfg = editor.config.get( 'enterToSend' ) || {};
		const enabled = cfg.enabled !== false; // default: true
		let mode = ( cfg.mode || 'enterSends' ); // 'enterSends' | 'shiftEnterSends' | 'buttonOnly'
		const callback = typeof cfg.callback === 'function' ? cfg.callback : null;
		const onModeChange = typeof cfg.onModeChange === 'function' ? cfg.onModeChange : null;

		if (!enabled) {
			return;
		}

		// expose API so other plugins (toolbar) can change it
		const api = {
			getMode: function() {
				return mode;
			},
			setMode: ( newMode ) => {
				if (!newMode || newMode === mode) {
					return;
				}
				mode = newMode;
				// tell listeners (toolbar) mode changed
				editor.fire( 'enterToSend:modeChange', { mode: newMode } );
				try {
					onModeChange && onModeChange( newMode, editor );
				} catch (e) {
				}
			},
			triggerSend: () => {
				if (callback) {
					try {
						callback( editor );
					} catch (e) {
					}
				} else {
					editor.fire( 'enterToSend' );
				}
			}
		};
		editor.enterToSend = api; // simple handle on editor instance
		this.api = api; // also keep on plugin instance

		const viewDocument = editor.editing.view.document;

		// IME compose guard
		let composing = false;
		this.listenTo( viewDocument, 'compositionstart', () => {
			composing = true;
		}, { priority: 'highest' } );
		this.listenTo( viewDocument, 'compositionend', () => {
			composing = false;
		}, { priority: 'highest' } );

		const stopEvt = ( evt, data ) => {
			if (data && data.domEvent && data.domEvent.preventDefault) {
				data.domEvent.preventDefault();
			}
			if (data && data.preventDefault) {
				data.preventDefault();
			}
			if (evt && evt.stop) {
				evt.stop();
			}
		};

		// BUTTON-ONLY → let editor behave normally, no key sends
		if (mode !== 'buttonOnly') {
			// prevent unwanted newline for the send-combo
			this.listenTo(
				viewDocument,
				'beforeinput',
				( evt, data ) => {
					if (composing) {
						return;
					}
					const domEvt = data && data.domEvent;
					if (!domEvt) {
						return;
					}

					const type = domEvt.inputType; // 'insertParagraph' (Enter) or 'insertLineBreak' (Shift+Enter)
					const isEnterInsert = type === 'insertParagraph';
					const isSoftBreakInsert = type === 'insertLineBreak';

					if (mode === 'enterSends') {
						if (isEnterInsert && !domEvt.shiftKey) {
							stopEvt( evt, data );
						}
					} else if (mode === 'shiftEnterSends') {
						if (isSoftBreakInsert || ( isEnterInsert && domEvt.shiftKey )) {
							stopEvt( evt, data );
						}
					}
				},
				{ priority: 'highest' }
			);

			// keydown → trigger send
			this.listenTo(
				viewDocument,
				'keydown',
				( evt, data ) => {
					if (composing) {
						return;
					}
					if (data.keyCode !== 13) {
						return;
					} // Enter
					if (mode === 'enterSends' && !data.shiftKey) {
						data.preventDefault();
						evt.stop();
						api.triggerSend();
					} else if (mode === 'shiftEnterSends' && data.shiftKey) {
						data.preventDefault();
						evt.stop();
						api.triggerSend();
					}
				},
				{ priority: 'highest' }
			);
		}
	}
}
